import * as React from 'react';
import classNames from 'classnames';
class SkeletonAvatar extends React.Component {
    render() {
        const { prefixCls, className, style, size, shape } = this.props;
        const sizeCls = classNames({
            [`${prefixCls}-lg`]: size === 'large',
            [`${prefixCls}-sm`]: size === 'small',
        });
        const shapeCls = classNames({
            [`${prefixCls}-circle`]: shape === 'circle',
            [`${prefixCls}-square`]: shape === 'square',
        });
        const sizeStyle = typeof size === 'number'
            ? {
                width: size,
                height: size,
                lineHeight: `${size}px`,
            }
            : {};
        return (<span className={classNames(prefixCls, className, sizeCls, shapeCls)} style={Object.assign({}, sizeStyle, style)}/>);
    }
}
SkeletonAvatar.defaultProps = {
    size: 'large',
};
export default SkeletonAvatar;
